export enum DsTableActionEnum {
  Edit,
  Delete,
  Collapse,
  Push,
  Validation,
}
